// removed by extract-text-webpack-plugin
module.exports = {"button":"src-components-Book----cartbutton-module---button---2scYi","padding":"src-components-Book----cartbutton-module---padding---14cF4","price":"src-components-Book----cartbutton-module---price---2OttS src-components-Book----cartbutton-module---padding---14cF4","icon":"src-components-Book----cartbutton-module---icon---3SFyU src-components-Book----cartbutton-module---padding---14cF4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Book/cartbutton.module.css
// module id = 322
// module chunks = 35783957827783